module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_kuessnacht-4f00c976cc0a5638256632b62cb6e861.png";